import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from 'apollo-upload-client';
import reduxStore from '../redux/store/store';

const uri = process.env.REACT_APP_GRAPHQL_ENDPOINT || 'https://qfjahes6dd.us-east-1.awsapprunner.com/graphql';

const link = createHttpLink({
  uri,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
  },
  fetch,
});

const uploadLink = createUploadLink({ uri });

const authLink = setContext((_, { headers }) => {
  // const { accessToken } = store.getState().session;
  // console.log('authLink:', reduxStore.store.getState());
  let accessToken = null;
  if (reduxStore.store.getState()?.session?.graphSession) {
    accessToken = reduxStore.store.getState()?.session?.graphSession?.accessToken;
  }
  // console.log('accessToken::', accessToken);

  return {
    headers: {
      ...headers,
      authorization: accessToken ? `Bearer ${accessToken}` : '',
    },
  };
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  // link: authLink.concat(link).concat(uploadLink),
  link: ApolloLink.from([authLink, link, uploadLink]),
});

export default client;
